import { render } from "./vision-mission.vue?vue&type=template&id=0cf1f698"
import script from "./vision-mission.vue?vue&type=script&lang=js"
export * from "./vision-mission.vue?vue&type=script&lang=js"
script.render = render

export default script